import React from 'react'
import { Helmet } from 'react-helmet'

import { EuiSpacer, EuiTitle } from '@elastic/eui'

import history from 'services/HistoryService'

import BillboardUploader from '../BillboardUploader'

const UploadStep: React.FC = () => {
  const gotoStart = () => {
    history.push('/campaigns/billboards/public/start')
  }

  return (
    <React.Fragment>
      <Helmet>
        <title>Upload Billboard</title>
      </Helmet>
      <EuiTitle size='s'>
        <h3>Upload Billboard</h3>
      </EuiTitle>
      <EuiSpacer size='m' />
      <BillboardUploader onBackClick={gotoStart} />
    </React.Fragment>
  )
}

export default UploadStep
